import React from 'react';
import { Form, Select } from "antd";
import CraftConst from '../../craft-const';
import Icons from "components/icons";
import { Localize } from "components/service";
import client from "graphql/client";
import { GET_ME } from "graphql/query/user-gql";
import MockData from "components/mock-data";


const CraftSelectTypeFormItem = ({
    form,
    disabled = false,
    rules = true,
    onChangeSetFilter = () => { },
    initialValue,
    mode = '',
    name = 'type',
    label = Localize({ children: "FORMS.Input_Label_CraftType" }).props.children,
    craftTypes = 'craftTypes',
    additionalFieldName = 'title',
    allowedTypes,
}) => {


    const options = allowedTypes && Array.isArray(allowedTypes)
        ? CraftConst[craftTypes].filter(({ type }) => allowedTypes.includes(type))
        : CraftConst[craftTypes];

    return (
        <Form.Item
            name={ name }
            label={ label }
            initialValue={ initialValue === 'mp_control' ? 'mp_control' : initialValue?.replace(/_/g, '') }
            rules={ rules && [ { required: true, message: `${ Localize({ children: "FORM_RULES.Required_Choose" }).props.children } ${ label }` } ] }
        >
            <Select
                showSearch
                showArrow
                mode={ mode }
                suffixIcon={ <Icons.Arrow /> }
                className="select-serch-input"
                disabled={ disabled }
                onChange={ value => {
                    form.setFieldsValue({ [ name ]: value });
                    onChangeSetFilter(false, name, value);
                } }
                placeholder={ `${ Localize({ children: "FORMS.Input_Placeholder_Choose" }).props.children }` }
                dropdownClassName="select-serch-dropdown craft-select"
                optionFilterProp="value"
                filterOption={ (input, option) => {
                    const term = String(input || '').toLowerCase();
                    const val = String(option?.value || '').toLowerCase();
                    const search = String(option?.search || '').toLowerCase();
                    return val.includes(term) || search.includes(term);
                } }
            >
                { options.map(({ type, title }) => {
                    let searchText = '';
                    if (typeof title === 'string') {
                        searchText = title;
                    } else if (title && title.props) {
                        const key = title.props.children;
                        const params = { ...title.props };
                        delete params.children;
                        const cached = client.readQuery({ query: GET_ME });
                        const lang = cached?.me?.language_slug || 'en';
                        let t = MockData.translation?.[ lang ]?.[ key ] || '';
                        if (t && params && Object.keys(params).length) {
                            Object.entries(params).forEach(([k, v]) => {
                                t = t.replace(new RegExp(`{ ${ k } }`, 'g'), String(v ?? ''));
                            });
                        }
                        searchText = t;
                    }
                    return (
                        <Select.Option key={ type } value={ type } search={ String(searchText || '') }>
                            <span onClick={ (e) => form.setFieldsValue({ [ additionalFieldName ]: e.target.childNodes[ 0 ].wholeText }) }> { title }</span>
                        </Select.Option>
                    );
                }) }
            </Select>
        </Form.Item>
    );
}

export default CraftSelectTypeFormItem;


